<style>
.left-border {
    border-left: 1px solid #555555;
    padding-left: 10px;
}
</style>
<template>
    <div ref="container" class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title">Blocking References</h2>
            <button type="button" aria-label="Close" class="close icon icon-close" @click.prevent="close" />
        </div>
        <div class="modal-body">
            <div class="form-group">
                <p>There are references to this datasource that would be impacted. You cannot delete columns or datasources that are in use.</p>
                <template v-if="result.references.length > 0">
                    <h5>References:</h5>
                    <div class="left-border" v-for="reference of result.references">
                        <strong>Column Name</strong>
                        <h6>{{ reference.columnName }}</h6>
                        <strong>Referenced In {{ reference.latest ? "The Latest" : "An In-Use Past" }} Definition</strong>
                        <h6>{{ reference.tenantLabel }} - {{ reference.formDefinitionLabel }} - {{ reference.settingLabel }}</h6>
                        <!-- TODO grouping
                        <ul>
                            <li v-for="fixup of fixupG[1]">{{ fixup.label }}</li>
                        </ul>
                         -->
                    </div>
                </template>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click.prevent="close">Close</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, SetupContext, ref } from "vue";
import { DatasourceModificationResult } from "@cs/DatasourceModificationResult";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { scopeSetup, ScopeProps } from "@/lib/cssScopes.3";
interface Props extends DialogProps, ScopeProps {
    result: DatasourceModificationResult;
}
export default defineComponent({
    props: ["result", "triggerElement", "cssScopes"],
    //@ts-ignore
    setup(props: Props, setupContext: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        scopeSetup(containerRef, props);
        dialogSetup(containerRef, props);

        const close = () => {
            setupContext.emit("close");
        };

        return {
            close,

            container: containerRef,
        };
    },
});
</script>
